import styled from "styled-components";

export const Button = styled.button`
  border: 2px solid #737da8;
  border-radius: 8px;
  width: 100%;
  padding: 10px;
  background-color: #4e5574;
  height: 32px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(/icons/molecule_icon.svg);
  background-repeat: no-repeat;
  background-position: right 15px center;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #737da8;
  }
`;

export const InputSearch = styled.input`
  border: 2px solid rgba(246, 251, 253, 0.28);
  border-radius: 12px;
  width: 100%;
  padding: 0 10px 3px;
  background-color: rgba(12, 17, 19, 0.85);
  height: 32px;
  padding-right: 5px;
  color: #fff;
  position: relative;
  z-index: 1;

  &::placeholder {
    font-size: 13px;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  background-color: rgba(12, 17, 19, 0.85);
  border: none;
  color: rgba(255, 255, 255, 0.9);
  padding: 5px 10px;
  outline: none;

  &::placeholder {
    color: rgba(255, 255, 255, 0.35);
  }
`;
export const SearchIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-left: 5px;
  margin-right: 10px;
  cursor: pointer;
`;

export const SearchInputWrapper = styled.div<{
  isopenpanel?: boolean;
  isnoborder?: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  width: ${({isopenpanel}) => (isopenpanel ? "100%" : "0px")};
  opacity: ${({isopenpanel}) => (isopenpanel ? "1" : "0")};
  background-color: rgba(12, 17, 19, 0.85);
  border: ${({isnoborder}) =>
    isnoborder ? "none" : "1px solid rgba(246, 251, 253, 0.28)"};
  padding: 2px 5px;
  border-radius: ${({isnoborder}) => (isnoborder ? "0px" : "12px")};
  transition: all 0.3s ease-in-out;
  margin-bottom: 10px;
`;

export const InputSearchResultBlock = styled.div`
  background-color: #161a1d;
  left: 0;
  right: 0;
  height: auto;
  position: absolute;
  top: 110px;
  z-index: 50;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 3px;
  margin-top: 10px;
  max-height: 80vh;
  overflow-y: auto;

  &::after {
    content: "";
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    pointer-events: none;
  }
  &::-webkit-scrollbar {
    width: 8px;
    border-radius: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #2a2d40;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #4e5574;
    border-radius: 4px;
    border-radius: 12px;
  }

  scrollbar-color: #4e5574 #2a2d40;
  scrollbar-width: thin;
`;

export const InputSearchResultItem = styled.div`
  color: #fff;
  position: relative;
  padding: 2px 3px 4px;
  margin: 4px 0;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: start;
  justify-content: start;
  gap: 8px;
  font-weight: 100;
  border-radius: 8px;

  img {
    margin-top: 4px;
  }

  p {
    line-height: 1;
    margin: 0;
  }

  &:hover {
    background-color: rgb(58, 64, 68);
  }
`;

export const SidebarInfoStyle = styled.div`
  .animate-slide-out {
    transition: transform 0.3s ease-in-out;
    transform: translateX(-100%);
  }
`;
